import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { getImage, GatsbyImage } from "gatsby-plugin-image"
import ReactMarkdown from "react-markdown"
import { useTranslation } from "react-i18next"
import { RaisedFloorDesc } from "../graphql/RaisedFloorSmallQueries"
import { Desc } from "../graphql/SidingSmallQueries"
import { HuldaasDesc } from "../graphql/HuldaasSmallQueries"

export const SingleHuldaasQuery = data => {
  // console.log(data)
  // console.log(RaisedFloorDesc()[0])
  // console.log(Desc()[0])
  // console.log(siding)
  const table = data?.table ?? undefined
  // const isSiding = table === "Siding"
  const path = data?.data ?? undefined
  const type = "p-tile"

  const hide = path?.Hide ?? undefined

  const { i18n } = useTranslation()
  const currentLanguage = i18n.language
  const mn = currentLanguage === "mn"
  const productType = HuldaasDesc()[0]?.name?.trim()
  const productCategory = "tile"

  const name = path?.Name?.trim() ?? undefined

  const slug = name ? name.replace(/\s+/g, "-").toLowerCase() : undefined

  const textMn = path?.textMn ?? undefined
  const textEn = path?.textEn ?? undefined
  const text = mn ? textMn : textEn

  const size = path?.size ?? undefined
  const ontslohBaraa = path?.ontsloh ?? undefined

  const imagepath = path?.Image ?? undefined
  const image = imagepath
    ? imagepath.localFiles?.map((item, index) => {
        const sharp = item ? getImage(item) : undefined
        return sharp ? (
          <GatsbyImage
            image={sharp}
            alt={`${name}-${index + 1}`}
            className="w-full"
          />
        ) : undefined
      })
    : undefined

  const brandpath = path?.Brand ?? undefined
  const brand = brandpath
    ? brandpath.map((item, index) => {
        const path = item?.data ?? undefined
        const nameMn = path?.mn ?? undefined
        const nameEn = path?.en ?? undefined
        const name = mn ? nameMn : nameEn

        const sharppath = path?.Logo ?? undefined
        const sharp = sharppath ? getImage(sharppath.localFiles[0]) : undefined
        const logo = sharp ? (
          <GatsbyImage image={sharp} alt={name} className="" />
        ) : undefined

        return { name, logo }
      })
    : undefined

  const countrypath = path?.country ?? undefined
  const country = countrypath
    ? countrypath.map((item, index) => {
        const path = item?.data ?? undefined
        const nameMn = path?.mn ?? undefined
        const nameEn = path?.en ?? undefined
        const name = mn ? nameMn : nameEn
        const sharppath = path?.Flag ?? undefined
        const sharp = sharppath ? getImage(sharppath.localFiles[0]) : undefined
        const flag = sharp ? (
          <GatsbyImage image={sharp} alt={name} className="w-full" />
        ) : undefined

        return { name, flag }
      })
    : undefined

  const colorPath = path?.Color ?? undefined
  const color = colorPath
    ? colorPath.map((item, index) => {
        const path = item?.data ?? undefined
        const hex = path?.hex ?? undefined
        const nameMn = path?.nameMn ?? undefined
        const nameEn = path?.nameEn ?? undefined
        const name = mn ? nameMn : nameEn
        const baraan = path?.baraan ?? undefined

        return { hex, name, baraan }
      })
    : undefined

  return {
    productCategory,
    table,
    productType,
    name,
    slug,
    text,
    size,
    ontslohBaraa,
    image,
    brand,
    country,
    color,
    type,
    hide,
  }
}

export default SingleHuldaasQuery
